
import React from "react";
import bodyHelperTypes from "../utils/BodyHelperTypes";
import UnorderedList from "../layouts/bodyLayouts/helpers/UnorderedList";
import Links from "../components/Links";



const LittleEyeProviderFAQ_Content = [

    {
        format: bodyHelperTypes.paragraphs,
        order: 10,
        content: [
            <>
                <b>Who can become a 1915(i) RISE service provider?</b><br />
                Organizations that may be eligible include:
                <ul>
                    <li>Community Mental Health Centers (CMHCs).</li>
                    <li>Behavioral health agencies.</li>
                    <li>Housing support providers.</li>
                    <li>Supported employment or education programs.</li>
                    {/* <li>Peer-run organizations.</li> */}
                    <li>Care coordination and case management agencies.</li>
                </ul>

                All providers must complete the <b>1915(i) RISE certification process</b> through the Department for Behavioral Health, Developmental and Intellectual Disabilities (DBHDID) and be <b>enrolled in Kentucky Medicaid.</b>

            </>,
            <>
                <b>What services can providers offer?</b><br />
                1915(i) RISE providers can deliver one or more of the following Medicaid-reimbursed services:
                <ol>
                    <li>Assistive Technology</li>
                    <li>Case Management</li>
                    <li>Housing and Tenancy Supports</li>
                    <li>In-Home Independent Living Supports</li>
                    <li>Medication Management</li>
                    <li>Planned Respite</li>
                    <li>Supervised Residential Care</li>
                    <li>Supported Education</li>
                    <li>Supported Employment</li>
                    <li>Transportation (Non-Medical)</li>
                </ol>
            </>,
            <>
                Conflict-free case management is a requirement of the 1915(i) RISE. Conflict-free case management means that the assessment and coordination of services are separate from the actual delivery of those services. As such, case management providers may not provide additional 1915(i) RISE services.
            </>,
            <>
                Each service has specific staff qualifications and service delivery requirements outlined in in <a href="https://apps.legislature.ky.gov/law/kar/titles/907/016/015/">907 KAR 16:015</a> and <a href="https://apps.legislature.ky.gov/law/kar/titles/907/016/020/">907 KAR 16:020</a>.
            </>,
            <>
                <b>How do I begin the provider certification process?</b><br />

                <ol>
                    <li>Complete New Provider Orientation – Level I (NPO L1).</li>
                    <li>Submit the 1915(i) RISE Certification Packet to 1915iRISEprovider@ky.gov.</li>
                    <li>Complete New Provider Orientation – Level II (NPO L2) after initial approval.</li>
                    <li>Undergo a policy, documentation, and staff review.</li>
                    <li>Receive a Certification Decision Letter from DBHDID.</li>
                    <li>Enroll through the Medicaid Provider Portal Application (MPPA).</li>
                </ol>
            </>,
            <>
                <b>What is the timeline for certification and enrollment?</b><br />
                The certification process includes multiple stages and may take several weeks. DBHDID aims to review submitted packets within <b>10 business days</b>, and scheduling for pre-service and on-site reviews depends on provider readiness.
            </>,
            <>
                <b>What training is required?</b><br />
                All 1915(i) RISE providers must complete:
                <ul>
                    <li><b>New Provider Orientation – Levels I & II</b> (for leadership).</li>
                    <li><b>Phase I </b>before delivering services.</li>
                    <li><b>Phase II </b>within six months of service start.</li>
                    <li><b>Phase III Service-Specific Training</b> (if applicable)</li>
                </ul>

              Training is provided through the Department for Medicaid Services’ (DMS’) <b>Adobe Learning Management (ALM) System.</b> 
            </>,
            <>
                <b>How are services reimbursed?</b><br/>
                1915(i) RISE services are reimbursed through <b>Kentucky Medicaid’s fee-for-service system.</b> Claims must be submitted in accordance with:
                <ul>
                    <li>The 1915(i) RISE fee schedule.</li>
                    <li>Billing and documentation standards.</li>
                    <li>Individualized Person-Centered Service Plans (PCSPs).</li>
                </ul>
            </>,
            <>
                <b>Can a provider deliver multiple 1915(i) RISE services?</b><br/>
                Yes. Organizations may choose to deliver one or multiple 1915(i) RISE services, depending on their qualifications, staffing, and capacity. However, some services (like Case Management) require <b>conflict-free</b> delivery and cannot be provided alongside other services for the same participant.
            </>,
            <>
                <b>Can I use existing staff for 1915(i) RISE services?</b><br/>
                Yes, as long as staff:
                <ul>
                    <li>Meet the <b>credentialing or licensure requirements.</b></li>
                    <li>Complete all <b>required 1915(i) RISE training.</b></li>
                    <li>Are assigned according to their scope of practice.</li>
                </ul>
            </>,
            <>
                <b>Where can I get help with the certification or enrollment process?</b><br/>
                Contact the 1915(i) RISE Initiative Provider Certification team:<br/><br/>

                <b>Email:</b><a href="mailto:1915iRISEprovider@ky.gov ">1915iRISEprovider@ky.gov </a><br/>
                <b>Phone:</b>502-564-9189 <br/>
                <b>Visit:</b><a href="https://dbhdid.ky.gov/1915iriseinitiative">https://dbhdid.ky.gov/1915iriseinitiative </a><br/>
                <b>MPPA Portal:</b><a href="https://medicaidsystems.ky.gov/Partnerportal/home.aspx">https://medicaidsystems.ky.gov/Partnerportal/home.aspx </a>
            </>,
            <>
                <b>What oversight or monitoring is involved?</b><br/>
                1915(i) RISE providers are subject to: <br/>
                <ul>
                    <li>Ongoing <b>program monitoring and quality reviews</b></li>
                    <li>Site visits and <b>documentation audits.</b></li>
                    <li>Annual or biennial re-certification.</li>
                    <li>Required participation in technical assistance and performance improvement if deficiencies are found.</li>
                </ul>
            </>,
            <>
                <b>What support is available to help me succeed?</b><br/>
                <ul>
                    <li>One-on-one technical assistance from DBHDID.</li>
                    <li>Access to job aids and sample documentation.</li>
                    <li>Billing and claims office hours.</li>
                    <li>Provider onboarding webinars.</li>
                    <li>Peer support and learning collaboratives (coming soon).</li>
                </ul>
            </>
        ]
    },



];

export default LittleEyeProviderFAQ_Content;